import { DollarSignFilled } from '@energy-retailer/icons';
import { Text } from '@/components/text';

type ProductPlanBannerProps = {
  bannerText?: string;
};

const ProductPlanCardBanner = ({ bannerText }: ProductPlanBannerProps) => (
  <div className="bg-product-plan-card-banner px-c py-a">
    {bannerText ? (
      <div className="flex items-center gap-b py-a text-product-plan-card-title">
          <DollarSignFilled className="h-5 w-5" fill="white" />
        <Text
          variant="body3"
          weight="semi"
        >
          {bannerText}
        </Text>
      </div>
    ) : null}
  </div>
);

export { ProductPlanCardBanner };
